import { render, staticRenderFns } from "./ChangeSuiteDropdown.vue?vue&type=template&id=5c3f5ca4&"
import script from "./ChangeSuiteDropdown.vue?vue&type=script&lang=js&"
export * from "./ChangeSuiteDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSuiteDropdown.vue?vue&type=style&index=0&id=5c3f5ca4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports